document.addEventListener('DOMContentLoaded', function () {
  if ($('.owl-carousel')[0]) {
    $('.owl-carousel').owlCarousel({
      loop: true,
      dots: false,
      margin: 0,
      nav: true,
      navText: ["<i class='text-red-500 icon-arrow-left-o leading-none block'></i>", "<i class='text-red-500 icon-arrow-right-o leading-none block'></i>"],
      autoplay: true,
      autoplayHoverPause: true,
      responsive: {
        0: {
          items: 2,
        },
        600: {
          items: 3,
        },
        1000: {
          items: 5,
          //autoWidth: true,
        },
      },
    })
  }

  if ($('.swiper-container')[0]) {
    var swiper = new Swiper('.swiper-container', {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: '.next',
        prevEl: '.prev',
      },
      coverflowEffect: {
        rotate: 0,
        stretch: -30,
        depth: 130,
        modifier: 1,
        slideShadows: false,
      },

      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 2.83,
          spaceBetween: 40,
        },
      },
    })
  }
})
